module.exports = new __parcel__URL__("fr_3.5245a318.png").toString();